import { Row } from 'antd';
import styled from 'styled-components';
import { IToken } from 'store/ducks/globalTypes';

export const StyledRow = styled(Row)<IToken>`
  padding: ${(props) => `${props.token.padding}px`};
`;
